import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import styled from "styled-components";
import Image from "next/image";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { useHomePageContext } from "@/src/features/home/HomePageContext";
import "react-photo-view/dist/react-photo-view.css";
import { useAppContext } from "@/src/config/AppProvider";

const GallerySection = () => {
  const { t } = useTranslation();
  const { getLocalization } = useAppContext();

  return (
    <div className="rbt-instagram-area bg-color-white rbt-section-gapTop">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb--60">
            <div className="section-title text-center">
              <span className="subtitle bg-secondary-opacity">{t("gallery")}</span>
              <h2 className="title">{getLocalization("gallerySlogan")}</h2>
            </div>
          </div>
        </div>
      </div>
      <Gallery />
    </div>
  );
};

const Gallery = (): ReactNode => {
  const { documents } = useHomePageContext();

  return (
    <PhotoProvider maskOpacity={0.8} maskClassName="custom-backdrop">
      <div className="container-fluid">
        <div className="row g-3 justify-content-center">
          {documents.map(item => (
            <div className="col-lg-2 col-md-4 col-sm-6 col-6" key={item.IdGuid}>
              <StyledImageWrapper className="instagram-grid">
                <PhotoView src={item.FileUrl}>
                  <Image
                    src={item.FileUrl}
                    width={320}
                    height={180}
                    alt={item.FileDescription}
                    style={{
                      height: 174,
                      objectFit: "cover"
                    }}
                  />
                </PhotoView>
              </StyledImageWrapper>
            </div>
          ))}
        </div>
      </div>
    </PhotoProvider>
  );
};

const StyledImageWrapper = styled.div`
  display: inline-block;
  overflow: hidden;

  img {
    transition: transform 0.5s ease-in-out;
    cursor: pointer;
  }

  img:hover {
    transform: scale(1.1);
  }
`;

export default GallerySection;
